import vue from "vue";
const axios = require("axios");
import qs from "qs";
import { PROXY_URL } from "../config/env";
import { store } from "../store/store";

let _axios = axios.create({
  withCredentials: true
});
export const fetch = function(url, params, needAuth) {
  return new Promise((resolve, reject) => {
    let p = { params: params };
    if (
      needAuth &&
      store.state.userInfo &&
      store.state.userInfo.authorization
    ) {
      p.headers = { Authorization: store.state.userInfo.authorization };
    }
    _axios
      .get(url, p)
      .then(response => {
        if (response.data.success && response.data.result) {
          return resolve(response.data.result);
        } else {
          return reject(response.data);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const post = function(url, params, needAuth) {
  return new Promise((resolve, reject) => {
    let o = null;
    if (
      needAuth &&
      store.state.userInfo &&
      store.state.userInfo.authorization
    ) {
      o = {
        headers: { Authorization: store.state.userInfo.authorization }
      };
    }
    _axios
      .post(url, params, o)
      .then(response => {
        if (response.data.success && response.data.result) {
          return resolve(response.data.result);
        } else {
          return reject(response.data);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};

/*
 * ---------------- 首页配置 ---------------
 * */

/**
 * 获取首页banner
 */

export const queryBanner = () =>
  axios.get(
    PROXY_URL.config + "/xubei-page-cloud/anon/h5/bannerImageSetting/getAll"
  );

/**
 * 获取首页类目列表
 */

export const getCategoryList = data =>
  axios.get(
    PROXY_URL.config + "/xubei-goods-cloud/anon/gameCategory/client/listName",
    { params: data }
  );

/*
 * 获取推荐游戏列表(登录状态)
 */

export const appRentPageConfig = data =>
  axios.get(PROXY_URL.user + "/usercenter/appRentPageConfig", {
    headers: { Authorization: store.state.userInfo.authorization }
  });

/*
 * 获取推荐游戏列表(未登录状态)
 */

export const rentPage = data =>
  axios.get(PROXY_URL.config + "/xubei-goods-cloud/anonappconfig/rentPage");

/*
 * 首页四款游戏列表
 */
export const getHomeGame = data =>
  axios.get(PROXY_URL.user + "/home/anon/getHomeGame");

/*
 * 公告管理
 */
export const queryNotice = () =>
  axios.get(PROXY_URL.config + "/xubei-page-cloud/anon/h5/noticeH5/getAll");

/*
 * 首页推荐
 */
export const queryPageRecommend = () =>
  axios.get(
    PROXY_URL.config + "/xubei-page-cloud/anon/h5/homePageRecommendH5/getAll"
  );

/*
 * 福利中心
 */

export const queryWelfare = () =>
  axios.get(
    PROXY_URL.config + "/xubei-page-cloud/anon/h5/welfareCenterSettingH5/getAll"
  );

/*
 * 获取游戏列表信息----新增接口
 */
export const getGameList = data =>
  axios.post(PROXY_URL.gameList, qs.stringify(data));

/*
 * 热销榜单
 */

export const getGameRank = () =>
  axios.get(
    PROXY_URL.config +
      "/xubei-page-cloud/anon/cms/getModDataByModId?modId=hot_list"
  );

/*
 * 福利中心 cms配置
 */

export const getBoonCenter = () =>
  axios.get(
    PROXY_URL.config +
      "/xubei-page-cloud/anon/cms/getModDataByModId?modId=h5_shouye_ad"
  );

/*
 * 热销搜索
 */
export const getHotGameSearch = () =>
  axios.get(
    PROXY_URL.config +
      "/xubei-page-cloud/anon/cms/getModDataByModId?modId=hot_game_search"
  );

/*
 * ---------------- user ---------------
 * */

/*
 * 登录---已更换user-api服务
 */
//user: '//user-api.test.xubei.com/user-api'
// export const loginRequest = (data) =>axios.post(PROXY_URL.user + '/businessUser/toLogin',qs.stringify(data));
//新接入的登录
// export const loginRequest = (data) =>axios.get(PROXY_URL.codeport + '/login/toLogin',qs.stringify(data));
// export const loginRequest = (udata) =>axios.get(PROXY_URL.codeport + '/app/login/toLogin?userName='+udata.userName+'&pwd='+udata.pwd);
export const loginRequest = data =>
  axios.get(PROXY_URL.codeport + "/login/toLogin", { params: data });

/*
 * 短信验证码登录 /sms/user/login
 */
export const smsLogin = data =>
  axios.get(PROXY_URL.codeport + "/sms/user/login", { params: data });

// 验证手机号是否注册
export const isRegister = data =>
  axios.get(PROXY_URL.codeport + "/reg/isPhoneExist", { params: data });

/*
 * 注册---更换user-api服务
 */

// export const registerRequest = (data) => axios.post(PROXY_URL.user + '/register/registerUser',qs.stringify(data));
export const registerRequest = data =>
  axios.get(
    PROXY_URL.codeport +
      "/reg/registerUser?mobile=" +
      data.mobile +
      "&loginPwd=" +
      data.loginPwd +
      "&code=" +
      data.code +
      "&channel=" +
      data.channel
  );

/*
 * 图形验证码安全校验
 */

export const getQueryCode = data =>
  axios.get(
    PROXY_URL.commonServer +
      `/anon/captcha/anon/captcha/getUrl?clientType=1&businessId=${data.businessId}`
  );
// export const getQueryCode = (data) => axios.get(PROXY_URL.codeport + '/reg/captcha/getUrl');

/*
 * 获取图形验证码
 */

export const queryCode = data => axios.get(PROXY_URL.user + "/code/getCode");

/*
 * 发送验证码
 */

// export const sendMobileCode = (data) => axios.post(PROXY_URL.user + '/mobile/sendMobileCode',qs.stringify(data));
export const sendMobileCode = data =>
  axios.get(
    PROXY_URL.commonServer +
      "/anon/sms/sendCode?mobile=" +
      data.mobile +
      "&businessNo=" +
      data.businessNo +
      "&ticket=" +
      data.ticket +
      "&businessId=" +
      data.businessId
  );

/*
 * 修改登录密码
 */
export const updatePwdRequest = data =>
  axios.post(PROXY_URL.user + "/businessUser/updatePwd", qs.stringify(data));

/*
 * 忘记密码----更换user-api服务
 */
// export const foundPwdRequest = (data) => axios.post(PROXY_URL.user + '/businessUser/foundPwd',qs.stringify(data));
export const foundPwdRequest = data =>
  axios.get(PROXY_URL.codeport + "/reg/changeLoginPwdExt", { params: data });

/*
 * 设置支付密码----更换user-api服务
 */
// export const foundPayPwdRequest = (data) => axios.post(PROXY_URL.user + '/businessUser/foundPayPwd',qs.stringify(data));
export const foundPayPwdRequest = data =>
  axios.get(
    PROXY_URL.user +
      "/acctSafe/forgetPayPwd?mobile=" +
      data.mobile +
      "&payPwd=" +
      data.payPwd +
      "&code=" +
      data.code,
    { headers: { Authorization: store.state.userInfo.authorization } }
  );

/*
 * 查询个人账号金额----更换user-api服务
 */
// export const queryAccountInfo = (data) => axios.post(PROXY_URL.user + '/account/accountInfo',qs.stringify(data));
export const queryAccountInfo = data =>
  axios.get(PROXY_URL.user + "/acctManage/index", {
    headers: { Authorization: store.state.userInfo.authorization }
  });

/*
 * 查询冻结资金明细
 */
export const getFreezeInfo = data =>
  axios.get(PROXY_URL.user + "/fund/getFreezeInfo", {
    headers: { Authorization: store.state.userInfo.authorization }
  });

// 查询登录信息
export const findUserDetail = data =>
  axios.post(
    PROXY_URL.user + "/businessUser/findUserDetail",
    qs.stringify(data)
  );

/*
 * ---------------- goods ---------------
 */

/*
 * 游戏区服
 */
export const queryGameArea = data =>
  axios.get(
    PROXY_URL.config +
      "/xubei-goods-cloud/anonapi/findGameAreaById?id=" +
      data.serverId
  );

/*
 * 查询游戏列表
 */
// export const queryGoodsList = (data) => axios.post(PROXY_URL.goodsList,qs.stringify(data));
export const queryGoodsList = data =>
  axios.post(PROXY_URL.config + "/b/goods/findGoodsList", qs.stringify(data));

// 根据游戏查询关键字
export const getImportantParam = params =>
  fetch(PROXY_URL.user + "/hotSearch/anon/getImportantParam", params);

// 查询所有游戏
export const queryGameType = data =>
  axios.get(PROXY_URL.goods + "/findGoodsAttr");

// 根据游戏查询筛选关键字
export const getGameSearchRelation = data =>
  axios.get(
    PROXY_URL.config + "/xubei-goods-cloud/anonapi/getGameSearchRelation",
    { params: data }
  );

// 根据类目查询商品类表
export const findLogoByCategory = data =>
  axios.get(
    PROXY_URL.config + "/xubei-goods-cloud/anonapi/findLogoByCategory",
    { params: data }
  );
/*
 * 商品详情
 */
// export const queryGoodDetail = (data) => axios.get(PROXY_URL.goods + '/goodsDetail?goodsId='+data.goodsId+'&businessNo=' + data.businessNo);

export const queryGoodDetail = params =>
  fetch(
    PROXY_URL.config + "/xubei-goods-cloud/anonapi/unifiedGoodsDetail",
    params
  );

export const addInitiator = params =>
  fetch(PROXY_URL.user + "/activity/addInitiator", params, true);

export const getModDataByModId = params =>
  fetch(
    PROXY_URL.config + "/xubei-page-cloud/anon/cms/getModDataByModId",
    params
  );

export const createOrder = params =>
  post(`${PROXY_URL.user}/buyer/createOrder`, params, true);

export const getOrderBalanceByOrderNo = params =>
  fetch(`${PROXY_URL.user}/pay/getOrderBalanceByOrderNo`, params, true);

export const payLaunchExt = params =>
  fetch(`${PROXY_URL.user}/pay/payLaunchExt`, params, true);

export const wxSignature = params =>
  fetch(
    `${PROXY_URL.config}/xubei-common-cloud/anon/wechat/gzh/get/jsapi/signature`,
    params
  );

export const getUserGoodsList = params =>
  fetch(`${PROXY_URL.user}/activity/getUserGoodslist`, params, true); //我的免费试玩商品

export const createBaseOrderOfJssdk = params =>
  fetch(
    `${PROXY_URL.config}/xubei-pay-gateway/anon/pay/gateway/createBaseOrderOfJssdk`,
    params
  ); //查询微信支付信息

/*
 * ---------------- order ---------------
 */

/*
 * 创建订单
 */
export const creatOrderRequest = data =>
  axios.get(PROXY_URL.order + "/goods/user/goodsStock", { params: data });

/*
 * 获取充值二维码
 */
export const fundRechargeQrcode = data =>
  fetch(PROXY_URL.user + "/fund/recharge", data, true);

/*
 *  充值轮询
 */
export const getTopupDetail = data =>
  fetch(PROXY_URL.user + "/pay/getTopupDetail", data, true);

/*
 *  余额支付
 */
export const payOrderMoney = data =>
  post(PROXY_URL.user + "/pay/payLaunchMixBiz", qs.stringify(data), true);

/*
 *  查询我的订单列表
 **/
// export const queryMyOrder = data =>
//   axios.post(
//     PROXY_URL.order + "/order/user/findOrderByUserOrder",
//     qs.stringify(data)
//   );

/*
 *  查询我的订单列表  新接口
 http://user-server.xubei-test.com/buyer/myLeaseOrderList?pageIndex=1&pageSize=10
 **/
export const queryMyOrder = data =>
  fetch(PROXY_URL.user + "/buyer/myLeaseOrderList", data, true);

/*
 *  查询订单详情
 **/
// export const queryOrderDetail = (data) => axios.post(PROXY_URL.order+'/order/user/findOrderItemByOrderNo',qs.stringify(data));
export const queryOrderDetail = params =>
  fetch(PROXY_URL.user + "/usercenter/getOrderDetail", params, true);

export const getOrderBalance = data =>
  axios.post(PROXY_URL.order + "/order/getOrderBalance", qs.stringify(data));
/*
 * ---------------- pay ---------------
 */

// 余额支付
// export const blancePay = (data) => axios.get(PROXY_URL.pay + '/pay/blancePay?orderNo=' + data.orderNo + '&token=' + data.token+ '&type=' + data.type + '&payPwd='+data.payPwd + '&businessNo=' + data.businessNo);

// 微信支付
// export const weiPay = (data) => axios.get(PROXY_URL.pay + '/pay/payBaseOrderOfWechat?orderNo=' + data.orderNo + '&token=' + data.token+ '&type=' + data.type + '&businessNo=' + data.businessNo);

/*
 *  ---------------续租、维权---------------
 **/

// 创建维权
export const leaseeSubArbitration = data =>
  axios.get(PROXY_URL.order + "/arbitration/leaseeSubArbitration", {
    params: data
  });

/*
 * 创建维权 新接口
 * http://user-server.xubei-test.com/arbitration/leaseeSubArb?wantRefundAmount=0.00&rightsProtection=123123&urls=http://files.xubei.com/demon/f0725f46b1ea477c90138791c7ae54e4.jpg&buyerApply=true&orderId=1522swx6bc3zi&rightsProblemId=58&sourceType=3
 */
export const leaseeSubArb = data =>
  fetch(PROXY_URL.user + "/arbitration/leaseeSubArb", data, true);

// 获取维权判定规则
export const getAllRightsRule = data =>
  axios.get(PROXY_URL.user + "/arbitration/getAllRightsRule", {
    headers: { Authorization: store.state.userInfo.authorization }
  });

// 获取维权问题
export const getRightsProblem = data =>
  fetch(PROXY_URL.user + "/arbitration/getRightsProblem", data, true);

// 撤销维权
export const overArbitration = data =>
  axios.get(
    PROXY_URL.order +
      "/arbitration/overArbitration?orderNo=" +
      data.orderNo +
      "&userId=" +
      data.userId +
      "&businessNo=" +
      data.businessNo
  );

// 维权记录
export const queryArbitrationInfo = data =>
  axios.get(
    PROXY_URL.order +
      "/arbitration/findArbitrationItem?orderNo=" +
      data.orderNo +
      "&userId=" +
      data.userId +
      "&businessNo=" +
      data.businessNo
  );

// 续租
export const orderRelet = data =>
  axios.get(PROXY_URL.order + "/order/orderRelet", { params: data });

// 续租充值订单
export const creatTopupOrder = data =>
  axios.post(PROXY_URL.order + "/topupOrder/createOrder", qs.stringify(data));

// 图片上传
export const upTemp = data =>
  axios.post("http://good-api.xubei.com/goods-api/arbitration/upTemp", data, {
    headers: { "Content-Type": "multipart/form-data" }
  });
/*
 *  ---------------埋点---------------
 **/
// app 下载
export const appLoad = data =>
  axios.post(PROXY_URL.order + "/arbitration/upTemp", qs.stringify(data));
// 下单返利注册
export const rebateRegister = data =>
  axios.get(PROXY_URL.codeport + "/reg/registerUser", { params: data });
//微信绑定
export const bindOpenId = data =>
  axios.post(
    PROXY_URL.codeport + "/weixinNoticeGrant/bindOpenId",
    qs.stringify(data)
  );
//微信绑定-通过手机
export const bindOpenIdByPhone = data =>
  axios.post(
    PROXY_URL.codeport + "/weixinNoticeGrant/bindOpenIdByPhone",
    qs.stringify(data)
  );

// 获取最近的领取记录
export const listReceive = data =>
  axios.get(PROXY_URL.user + "/redenvelope/prize/anon/carnival/listReceive", {
    params: { userType: data.userType },
    headers: { Authorization: data.token }
  });

// 获取奖品记录
export const listPrize = data =>
  axios.get(
    PROXY_URL.user + "/redenvelope/prize/anon/carnival/order/listPrize",
    {
      params: { userType: data.userType },
      headers: { Authorization: data.token }
    }
  );

// 点击立即领取
export const nowPrizeId = data =>
  axios.get(PROXY_URL.user + "/redenvelope/prize/carnival/order/get", {
    headers: { Authorization: data.token },
    params: data
  });

/*
 * 获取用户类型和活动时间
 */
export const getConfigPrize = data =>
  axios.get(PROXY_URL.user + "/redenvelope/prize/anon/newUser/getConfig", {
    headers: data
  });

/* 获取推荐优惠券接口
 * businessNo: 'xubei_m',
 * gameId: ,
 * sellerId: , 商户ID
 * orderAmount:
 */
export const getCouponList = data =>
  axios.get(PROXY_URL.user + "/buyer/myOrderCouponList", {
    params: data,
    headers: { Authorization: store.state.userInfo.authorization }
  });

/* 获取所有优惠券接口
 * businessNo: 'xubei_m',
 * activityType: 1.平台2.店铺,
 */
export const getMyCouponList = data =>
  axios.get(PROXY_URL.user + "/coupon/buyer/myList", {
    params: data,
    headers: { Authorization: store.state.userInfo.authorization }
  });

/*
 * 获取阿里云客服链接参数
 */
export const getEncrypt = () =>
  axios.get(PROXY_URL.user + "/cloudservice/user/encrypt", {
    headers: { Authorization: store.state.userInfo.authorization }
  });

/*
 * 获取我的红包可用总金额 businessNo=oppo&activityType=1
 */
export const getUsableCouponAmount = data =>
  axios.get(PROXY_URL.user + "/coupon/buyer/getUsableCouponAmount", {
    params: data,
    headers: { Authorization: store.state.userInfo.authorization }
  });

// 百度转化接口
export const baiduReportAPI = params =>
  post(
    PROXY_URL.user + "/anon/ocpc/sendConvertData",
    qs.stringify(params),
    true
  );

// 获取上号引导页面 ?gameId=1109
export const obtainLink = data =>
  axios.get(
    PROXY_URL.config + `/xubei-goods-cloud/anon/accountHelp/obtainLink`,
    {
      params: data
    }
  );

// 获取栏目列表
export const getCategoryListNew = data =>
  axios.get(PROXY_URL.user + `/merchant/config/anon/getCategoryList`, {
    params: data
  });

// 获取栏目对应的游戏列表
export const getCategoryGameList = data =>
  axios.get(PROXY_URL.user + `/merchant/config/anon/getCategoryGameList`, {
    params: data
  });


// WEBPACK FOOTER //
// ./src/service/getData.js